import React, { useEffect, useState } from "react";

import Input from "../../../components/FormComponents/Input";
import Textarea from "../../../components/FormComponents/Textarea";
import { useAxiosContext } from "../../../context/AxiosContext";
import Button from "../../../components/FormComponents/Button";

const DBSettings = ({ selectedConnectorId }) => {
  const [selectedConnector, setSelectedConnector] = useState(null);
  const [updatedConnector, setUpdatedConnector] = useState(null);

  const { axiosInstance, handleError, handleSuccess } = useAxiosContext();

  useEffect(() => {
    const getConnector = async () => {
      try {
        const { data } = await axiosInstance.get(`/dbconnector/${selectedConnectorId}`);

        const filteredData = {
          name: data.name,
          database: data.database,
          description: data.description,
          host: data.host,
          port: typeof data.port === "number" ? data.port : null,
          schema_name: data.schema_name || "" // 👈 EXTRACT SCHEMA NAME
        };

        setSelectedConnector(filteredData);
        setUpdatedConnector(filteredData);
      } catch (error) {
        handleError(error);
      }
    };

    if (selectedConnectorId) {
      getConnector();
    }
  }, [selectedConnectorId, axiosInstance, handleError]);

  // ===============================
  // CHANGE HANDLER (PORT AS INT)
  // ===============================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setUpdatedConnector((prev) => ({
      ...prev,
      [name]: name === "port" ? (value === "" ? null : parseInt(value, 10)) : value
    }));
  };

  const handleSave = async () => {
    if (updatedConnector.port === null || updatedConnector.port < 1 || updatedConnector.port > 65535) {
      handleError({ message: "Port must be between 1 and 65535" });
      return;
    }

    try {
      // Send the update (ensure backend PATCH handler accepts 'schema' string)
      const { message } = await axiosInstance.patch(`/dbconnector/${selectedConnectorId}`, updatedConnector);

      setSelectedConnector(updatedConnector);
      handleSuccess(message);
    } catch (error) {
      handleError(error);
    }
  };

  return (
    selectedConnector && (
      <div className="d_flex justify_center mt_4">
        <div className="db_settings">
          <h4 className="mb_1">General</h4>

          <Input
            containerClassName="mb_3"
            label="Name"
            name="name"
            value={updatedConnector?.name || ""}
            onChange={handleChange}
          />

          <Textarea
            label="Description"
            name="description"
            value={updatedConnector?.description || ""}
            onChange={handleChange}
          />

          <h4 className="mt_4 mb_3">Credentials</h4>

          <div className="d_flex gap_3">
            <Input
              containerClassName="mb_3 flex_1" // flex_1 for equal width
              label="Host"
              name="host"
              value={updatedConnector?.host || ""}
              onChange={handleChange}
            />

            <Input
              containerClassName="mb_3 flex_1"
              label="Port"
              name="port"
              type="number"
              min={1}
              max={65535}
              value={updatedConnector?.port ?? ""}
              onChange={handleChange}
            />
          </div>

          <div className="d_flex gap_3">
            <Input
              containerClassName="mb_3 flex_1"
              label="Database Name"
              name="database"
              value={updatedConnector?.database || ""}
              onChange={handleChange}
            />

            {/* 👇 NEW SCHEMA INPUT ADDED HERE */}
            <Input
              containerClassName="mb_3 flex_1"
              label="Schema"
              name="schema_name"
              placeholder="public" // Helpful default hint
              value={updatedConnector?.schema_name || ""}
              onChange={handleChange}
            />
          </div>

          <div className="d_flex justify_end mt_3">
            <Button onClick={handleSave}>Save</Button>
          </div>
        </div>
      </div>
    )
  );
};

export default DBSettings;
